import axios from 'axios';
import {useCallback, useEffect, useRef, useState} from 'react';

import httpClient from 'httpClient';

export default function useHttpClient(axiosParams) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const source = useRef(axios.CancelToken.source());
  const params = useRef(axiosParams);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const {data} = await httpClient.request({
        ...params.current,
        cancelToken: source.current.token,
      });

      setData(data);
      setLoading(false);
    } catch (error) {
      if (!axios.isCancel(error)) {
        setError(error);
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const sourceToken = source.current;
    const requestParams = params.current;

    (async () => {
      await fetchData(requestParams, sourceToken.token);
    })();
  }, [fetchData]);

  useEffect(() => {
    params.current = axiosParams;
  }, [axiosParams]);

  return {
    data,
    error,
    loading,
    cancel: source.current.cancel,
    refetch: fetchData,
  };
}
